module.exports = __webpack_public_path__ + "media/media/advantages/_international_team-cd59e7fca461d610088d0f3291971ded.png";